// @flow
import styled from 'styled-components'
import { Layout, Card } from 'antd'
const { Content } = Layout

export const StyledContent = styled(Content)`
    background: #fff;
    margin: 24px 16px;
    padding: 20px;
`

export const StyledList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    & .ant-badge-status {
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        text-overflow: ellipsis;
        font-size: 12px;
    }
`

export const NotesMonth = styled.div`
    text-align: center;
    font-size: 28px;
    & section {
      font-size: 28px;
    }
`

export const CalenderItemBox = styled(Card)`
    height: 180px;
    background: #206176 !important;
    border-radius: 5px; 
    color : white
    text-transform: uppercase;
    div:hover {
        background-color: #90b0bb;
        cursor: pointer;
    }
    .ant-card-body {
        display: flex;
        align-items: center;
        height: 100%;
        font-weight: bold;
        justify-content: center;
    }
    &.color-blue {
      background: #1890FF !important;
    }
`

export const StyledSection = styled.section`
  height: 285px;
  width: 100%;
`

export const StyledCard = styled(Card)`
  height: 100%;
  width: 100%;
`

export const StyledModalTitle = styled.div`
  display: flex;
  
  .title {
      padding: 10px 25px;
  }
  
  .dateView {
      position: absolute;
      top: 0;
      left: 0;
  }
  
 .date { 
      display: flex;
      flex-direction: column;
      left: 10px;
      top: 7px;
      text-align: center;
    
      span { 
        line-height: 10px;
        font-size: 10px;
      } 
 }
`


// WEBPACK FOOTER //
// ./src/components/view-calendar/style.js